import axios from "axios";
import { useQuery } from "react-query";

const useFetch = (key, url, options = {}) =>
  useQuery(key, () => axios.get(url).then(({ data }) => data), {
    retry: 3,
  });

export default useFetch;
